import React from 'react'
import { Pool } from '../core/types'
import { nf, SEVERITY_COLOR } from '../core/consts'
import { METRIC_HINTS } from '../core/hints'
import InfoHint from '../../../../../common/InfoHint'

type Props = {
  pools: Pool[]
  currency: string
}

// Isolation pools: strict merchants are closed islands (own supply/demand);
// "shared" is the common pool (default/priority/exclude share liquidity).
const PoolsBreakdown: React.FC<Props> = ({ pools, currency }) => {
  if (!pools || pools.length === 0) return null

  const label = (p: Pool) =>
    p.mode === 'strict' ? `Изолированный: ${p.merchant || p.key}` : 'Общий пул'

  return (
    <div className='card mb-5'>
      <div className='card-header'>
        <h3 className='card-title d-inline-flex align-items-center'>
          Пулы изоляции ({currency})
          <InfoHint text={METRIC_HINTS.pools} />
        </h3>
      </div>
      <div className='card-body'>
        <div className='table-responsive'>
          <table className='table table-sm table-row-bordered align-middle'>
            <thead>
              <tr className='fw-bold text-muted'>
                <th>Пул</th>
                <th className='text-end'>Выплаты</th>
                <th className='text-end'>Остаток</th>
                <th className='text-end'>Депозиты</th>
                <th className='text-end'>Спрос</th>
                <th className='text-end'>Покрытие</th>
              </tr>
            </thead>
            <tbody>
              {pools.map((p) => (
                <tr key={p.key}>
                  <td>
                    <span className={`bullet bullet-dot bg-${SEVERITY_COLOR[p.severity]} me-2`} />
                    {label(p)}
                  </td>
                  <td className='text-end'>{nf.format(p.active_payouts)}</td>
                  <td className='text-end'>{nf.format(Math.round(p.payout_remainder))}</td>
                  <td className='text-end'>{nf.format(p.active_deposits)}</td>
                  <td className='text-end'>{nf.format(Math.round(p.deposit_demand))}</td>
                  <td className='text-end'>
                    {p.deposit_demand > 0 ? `${p.coverage_pct.toFixed(0)}%` : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className='text-muted fs-8 mt-2'>
          Изолированные (strict) мерчанты — закрытые пулы: их выплаты обслуживают только их
          депозиты.
        </div>
      </div>
    </div>
  )
}

export default PoolsBreakdown
